import type { PlanFeature } from "./plans";

/**
 * Opens the upgrade dialog from anywhere: buttons at a limit call it directly, and every mutation
 * the server refuses for the plan calls it through the query client (App.tsx). The dialog
 * (components/upgrade/upgrade-dialog.tsx) is the only listener.
 */
type Listener = (feature: PlanFeature) => void;
const listeners = new Set<Listener>();

export function requestUpgrade(feature: PlanFeature): void {
  for (const listener of listeners) listener(feature);
}

export function onUpgradeRequest(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
